/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Filter_InactiveInputs */

const cs_templates_filter_inactive = /** @type {(inputs: Templates_Filter_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neaktivní`)
};

const en_templates_filter_inactive = /** @type {(inputs: Templates_Filter_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Templates_Filter_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_filter_inactive = /** @type {((inputs?: Templates_Filter_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Filter_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_filter_inactive(inputs)
	return cs_templates_filter_inactive(inputs)
});